import { render, staticRenderFns } from "./SettingsAdminCreate.vue?vue&type=template&id=96a5dec0&"
import script from "./SettingsAdminCreate.vue?vue&type=script&lang=js&"
export * from "./SettingsAdminCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports